import type { MarketVariants } from '@/lib/i18n'

export type Slide6TipsCopy = {
  title: string
  tip1Label: string
  tip1Body: string
  tip2Label: string
  tip2Body: string
  tip3Label: string
  tip3Body: string
}

export const copy: MarketVariants<Slide6TipsCopy> = {
  US: {
    title: 'Rules to Remember',
    tip1Label:
      'No real emergency needs you to act in the next five minutes.',
    tip1Body:
      "Time is always on your side. If it's real, it will still be there after you've checked.",
    tip2Label: "If you didn't start it, you don't owe it anything.",
    tip2Body:
      "Unsolicited contact hasn't earned your trust, your time, or your personal info.",
    tip3Label: 'Anyone who discourages checking is telling on themselves.',
    tip3Body:
      'Real companies and trustworthy people will never discourage you from verifying independently.',
  },
  ar: {
    title: 'قواعد تذكّرها دائماً',
    tip1Label:
      'لا توجد حالة طارئة حقيقية تتطلب منك التصرّف خلال الدقائق الخمس القادمة.',
    tip1Body:
      'الوقت دائماً في صالحك. إن كان الأمر حقيقياً، فسيبقى قائماً بعد أن تتحقق.',
    tip2Label: 'إن لم تكن أنت من بدأ التواصل، فلست مديناً له بشيء.',
    tip2Body:
      'التواصل الذي لم تطلبه لم يكسب ثقتك ولا وقتك ولا معلوماتك الشخصية.',
    tip3Label: 'من يثنيك عن التحقق يكشف عن نفسه.',
    tip3Body:
      'الشركات الحقيقية والأشخاص الجديرون بالثقة لن يثنوك أبداً عن التحقق بشكل مستقل.',
  },
}
